import React from "react";
import { pointsConfig } from "../../../../pointsConfig";
import { milesPointUserRank } from "../../../../controllers/pointsController";
// import { milesPointUserRank } from "../../../../controllers/pointController";

function MilesRankDetailModalHeader({ board }) {
  const rankStatus = milesPointUserRank(board?.totalAmount || 0);
  const image =
    board?.rank === 1
      ? "./1stTag.svg"
      : board?.rank === 2
        ? "./2ndTag.svg"
        : board?.rank === 3
          ? "./3rdTag.svg"
          : undefined;

  return (
    <div className="p-4 w-full flex items-center gap-3 sticky top-0 bg-white">
      <img src={rankStatus.icon} alt="" className="w-20 object-contain" />
      <div className="flex flex-1 flex-col gap-2">
        <div className="w-full flex items-center justify-between gap-2">
          <div className="flex flex-1 flex-col">
            <span className="font-BrFirmaBold">{board?.companyName}</span>
            <span className="text-[#606060]">{rankStatus.label}</span>
          </div>
          {image ? (
            <img src={image} alt="" className="h-14 object-contain -mr-4" />
          ) : (
            <></>
          )}
        </div>
        <div className="w-full h-4">
          <div className="w-full h-full rounded-full bg-[#F3F5F9] font-bold relative">
            <div
              className={`h-full  rounded-full bg-[#06E775]`}
              style={{ width: `70%` }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MilesRankDetailModalHeader;
